module.exports = __webpack_public_path__ + "static/img/about.45df1b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about.png
// module id = FhzR
// module chunks = 1